export default __webpack_public_path__ + "static/media/tag-icon-mobility.488d7ed8.svg";